// extracted by mini-css-extract-plugin
module.exports = {"text_input":"TextInput_text_input__1l_NL","text_input_icon":"TextInput_text_input_icon__2-NJc"};